import { PropTypes } from 'prop-types';
import './RadioGroup.css'
RadioGroup.propTypes = {
    onChange: PropTypes.func
}
export default function RadioGroup(props){
    return <div onChange={props.onChange} className='t-radio-group'>
        {props.children}
    </div>
}